export const DATATEST = {
    ROOT: "reusable__feature-flagged-component__loading-component",
};
